<template>
  <div id="app">
    <!--<code>{{ carts }}</code>-->
    <div class="wrapper" v-bind:class="{ singleorder: singleorder == true }">

      <div id="content-area" class="fullwidth">
        <!--<div id="preloader-show" v-if="isLoading">-->
        <!--<img  src="@/assets/images/circle-loader.gif" />-->
        <!--</div>-->

        <nav class="small-device-nav opensidebar">
          <div class="sub">
            <table class="table table-responsive">
              <tr>
                 <td width="60px">
                  <div class="menu-collapse-btn" style="  margin-left: 15px;" @click="toogleNav()">
                    <img src="@/assets/images/icons/collapse.png" class="show-icon" alt="" />
                    <!--<img src="@/assets/images/icons/collapse.png" class="show-icon" alt=" " v-if="menuStatus==true"/>-->
                    <!--<img src="@/assets/images/icons/close-icon.png" class="hide-icon" alt=" " v-else/>-->
                  </div>
                </td>
                <td class="hide-td text-center">
                  <router-link :to="{ path: '/' }" style="  margin-left: -70px;">
                    <img src="@/assets/images/ghasforing-logo.png" height="40px" />
                  </router-link>
                </td>

                <td class="search-td">
                  <div class="search-img" @click="goSearch">
                    <img class="black-search" src="@/assets/images/search.png" alt=" " />
                    <img class="white-search" src="@/assets/images/search-white.png" alt=" " />
                  </div>
                  <form v-on:submit.prevent>
                    <input type="text" v-if="language == 'EN'" v-on:keyup.enter="goSearch" v-model="searchProduct"
                      class="custom-search" placeholder="Search Products (e.g: Atta, Chal, Dal, Sugar, Oil, Salt )" />
                    <input type="text" v-else v-on:keyup.enter="goSearch" v-model="searchProduct"
                      class="custom-search" placeholder="পণ্য অনুসন্ধান করুন (যেমন:  চাল, ডাল, আটা, চিনি, তেল, লবণ )" />
                  </form>
                </td>
                <td class="fix-width">
                  <div class="pull-left">

                    <span class="carts" @click.prevent.stop="toggleSideCart">
                      <span class="badge">{{ cart_quantity || 0 }}</span>
                      <i class="icon-login"></i>
                      <img src="@/assets/images/icons/bag.png" alt="Shopping-bag" height="40px" />
                    </span>
                  </div>
                  <div class="pull-right toplinks hidden-xs">
                    <a href="" v-on:click="changeLanguage('EN')">ENG </a>
                    |
                    <a href="" @click="changeLanguage('BN')"> বাংলা</a>
                    |
                    <a href="#" data-toggle="modal" data-target="#loginModal" v-if="!logged_in_user_name"><img
                        src="@/assets/images/icons/login.svg" height="16px" />&nbsp;&nbsp;SIGN IN</a>
                    <a href="#" class="dropdown-toggle" data-toggle="dropdown" v-if="logged_in_user_name">
                      <img src="@/assets/images/icons/profile.png" height="28px" />
                    </a>
                    <ul class="dropdown-menu clearfix bigdropdown" role="menu">
                      <!-- <li v-if="logged_in_user_name && is_seller == 1">
                      <router-link to="/marketer-sells"><span><img
                            src="@/assets/images/icons/diagram-icon.png" /></span>
                        My Income
                      </router-link>
                    </li> -->
                      <!-- <li>
                      <router-link to="/my-deposit" v-if="logged_in_user_name"><span><img
                            src="@/assets/images/icons/diagram-icon.png" /></span>

                        My Deposit
                      </router-link>
                    </li> -->
                      <!-- <li>
                      <router-link to="/deposit-history" v-if="logged_in_user_name"><span><img
                            src="@/assets/images/icons/diagram-icon.png" /></span>

                        Deposit History
                      </router-link>
                    </li> -->
                      <li v-if="logged_in_user_name">
                        <router-link to="/myorders"><span><img src="@/assets/images/icons/diagram-icon.png" /></span>
                          My Orders
                        </router-link>
                      </li>
                      <li v-if="logged_in_user_name">
                        <router-link to="/my-profile"><span><img src="@/assets/images/icons/diagram-icon.png" /></span>
                          My Profile
                        </router-link>
                      </li>
                      <!-- <li>
                      <router-link to="/gift"><span><img src="@/assets/images/icons/diagram-icon.png" /></span>
                        Earn Gift Money
                      </router-link>
                    </li> -->
                      <!--                    <li v-if="logged_in_user_name">-->
                      <!--                      <router-link to="/my-account"><span><img src="@/assets/images/icons/user-black.png"></span> My-->
                      <!--                        Account-->
                      <!--                      </router-link>-->
                      <!--                    </li>-->
                      <li v-if="logged_in_user_name">
                        <a href="" @click="logout"><span><img src="@/assets/images/icons/logout-square.png" /></span>
                          Logout</a>
                      </li>
                    </ul>
                  </div>
                  <div class="visible-xs dropdown pull-right">
                    <a href="#" class="dropdown-toggle" data-toggle="dropdown">
                      <span class="dots">
                        <img src="@/assets/images/dots.png" alt=" " />
                      </span>
                    </a>
                    <ul class="dropdown-menu clearfix" role="menu">
                      <li>
                        <a href="" v-on:click="changeLanguage('BN')"><span><img
                              src="@/assets/images/icons/45.png" /></span>&nbsp; বাংলা</a>
                      </li>
                      <li>
                        <a href="" @click="changeLanguage('EN')"><span><img
                              src="@/assets/images/icons/45.png" /></span>&nbsp; ENG</a>
                      </li>
                      <li v-if="!logged_in_user_name">
                        <a href="" data-toggle="modal" data-target="#loginModal"><span><img
                              src="@/assets/images/icons/login.png" /></span>&nbsp; Login</a>
                      </li>
                      <li v-if="!logged_in_user_name">
                        <a href="" data-toggle="modal" data-target="#signupModal"><span><img
                              src="@/assets/images/icons/entry.png" /></span>Register</a>
                      </li>
                      <!--<li  v-if="logged_in_user_name"><a href=""><span><img src="@/assets/images/icons/person.png"></span> My Profile</a></li>-->
                      <!-- <li v-if="logged_in_user_name && is_seller == 1">
                      <router-link to="/marketer-sells"><span><img
                            src="@/assets/images/icons/diagram-icon.png" /></span>
                        My Sells
                      </router-link>
                    </li> -->
                      <!-- <li>
                      <router-link to="/my-deposit" v-if="logged_in_user_name"><span><img
                            src="@/assets/images/icons/diagram-icon.png" /></span>

                        My Deposit
                      </router-link>
                    </li> -->
                      <!-- <li>
                      <router-link to="/deposit-history" v-if="logged_in_user_name"><span><img
                            src="@/assets/images/icons/diagram-icon.png" /></span>

                        Deposit History
                      </router-link>
                    </li> -->
                      <li v-if="logged_in_user_name">
                        <router-link to="/myorders"><span><img src="@/assets/images/icons/diagram-icon.png" /></span>
                          My Orders
                        </router-link>
                      </li>
                      <li v-if="logged_in_user_name">
                        <router-link to="/my-profile"><span><img src="@/assets/images/icons/diagram-icon.png" /></span>
                          My Profile
                        </router-link>
                      </li>
                      <!-- <li>
                      <router-link to="/gift"><span><img src="@/assets/images/icons/diagram-icon.png" /></span>
                        Earn Your Gift
                      </router-link>
                    </li> -->
                      <li v-if="logged_in_user_name">
                        <a href="" @click="logout"><span><img src="@/assets/images/icons/logout-square.png" /></span>
                          Logout</a>
                      </li>
                    </ul>
                  </div>
                </td>
              </tr>
            </table>
          </div>
        </nav>
        <div class="main-content">
          <div id="sidebar-area" v-bind:class="{ 'hidden-sidebar': !menuStatus }">
            <app-header @close-menu="closeMobileMenu"></app-header>
          </div>
          <div class="routepage" v-bind:class="{ fullscreen: !menuStatus }">
             <router-view></router-view>
             <CartData
              v-if="showGlobalSideCart"
              :carts="carts"
              :sum-cart-total="sum_cart_total || 0"
              :file-url="fileUrl"
              :global-language="globalLanguage"
              @remove-cart-item="removeCartItem"
              @cart-increment="cartIncrement"
              @cart-decrement="cartDecrement"
            />
            <div class="extra-area">
        <div class="sha-footer-cities">
        <div class="containers">
                  <div class="sha-footer-cities-inner">
                    <span class="sha-footer-cities-title">Cities</span>
                    <button type="button" class="sha-city-chip">Paris (75)</button>
                    <button type="button" class="sha-city-chip">les Hauts-de-Seine (92)</button>
                    <button type="button" class="sha-city-chip">la Seine-Saint-Denis (93)</button>
                    <button type="button" class="sha-city-chip">le Val-de-Marne (94)</button>
                    <button type="button" class="sha-city-chip">la Seine-et-Marne (77)</button>
                    <button type="button" class="sha-city-chip">les Yvelines (78)</button>
                    <button type="button" class="sha-city-chip">l'Essonne (91)</button>
                    <button type="button" class="sha-city-chip">le Val-d'Oise (95)</button>
                  </div>
                </div>
                </div>
          <div>

            <div class="col-md-12">
              <div class="row footer sha-footer">


                <div class="sha-footer-main">
                  <div class="sha-footer-left">
                    <img
                      src="@/assets/images/ghasforing-logo.png"
                      alt="Shah Premium Foods"
                      class="sha-footer-logo"
                    />
                    <div class="sha-footer-description" v-if="language == 'EN'">
                      <h2>SHAH PREMIUM FOODS</h2>
                      <h4>Your Online Supermarket in Île-de-France</h4>
                      <p>
                        Welcome to SHAH PREMIUM FOODS, your trusted online
                        supermarket for fresh food, quality groceries, and
                        everyday essentials across Île-de-France. From fresh vegetables, fish, and chicken to organic
                        foods, groceries, household essentials, and non-food
                        products, we bring carefully selected products together
                        in one convenient online shop.
                      </p>
                      <strong>Everything You Need, Delivered to Your Door</strong>
                      <span>SHAH PREMIUM FOODS — Your Everyday Shopping, Made Easy.</span>
                    </div>
                    <div class="sha-footer-description" v-else>
                      <h2>SHAH PREMIUM FOODS</h2>
                      <h4>Île-de-France-এ আপনার অনলাইন সুপারমার্কেট</h4>
                      <p>
                        SHAH PREMIUM FOODS-এ স্বাগতম। Île-de-France জুড়ে তাজা
                        খাবার, মানসম্মত গ্রোসারি এবং প্রতিদিনের প্রয়োজনীয় পণ্যের
                        জন্য আমরা আপনার বিশ্বস্ত অনলাইন সুপারমার্কেট।
                        তাজা সবজি, মাছ, চিকেন, অর্গানিক খাবার, গ্রোসারি,
                        গৃহস্থালি প্রয়োজনীয় পণ্য এবং নন-ফুড আইটেমসহ বাছাই করা
                        পণ্যের বিস্তৃত সংগ্রহ আমরা এক জায়গায় নিয়ে এসেছি।
                      </p>
                      <strong>Everything You Need, Delivered to Your Door</strong>
                      <span>SHAH PREMIUM FOODS — Your Everyday Shopping, Made Easy.</span>
                    </div>

                    <div class="sha-footer-links-grid">
                      <div class="sha-footer-column">
                        <h3 v-if="language == 'EN'">Address</h3>
                        <h3 v-else>ঠিকানা</h3>
                        <p>
                          Paris, France<br />
                          Delivery Time: 8AM To 9PM
                        </p>
                      </div>
                      <div class="sha-footer-column">
                        <h3 v-if="language == 'EN'">Quick Links</h3>
                        <h3 v-else>কুইক লিংক</h3>
                        <ul>

                          <li>
                            <router-link :to="{ path: '/delivery-locations' }">
                              <span v-if="language == 'EN'">Delivery Locations</span>
                              <span v-else>ডেলিভারি এলাকা</span>
                            </router-link>
                          </li>
                          <li>
                            <router-link :to="{ path: '/contact-us' }">
                              <span v-if="language == 'EN'">Contact Us</span>
                              <span v-else>যোগাযোগ করুন</span>
                            </router-link>
                          </li>
                        </ul>
                      </div>
                      <div class="sha-footer-column">
                        <h3 v-if="language == 'EN'">Terms & Policies</h3>
                        <h3 v-else>নীতিমালা</h3>
                        <ul>
                          <li>
                            <router-link :to="{ path: '/terms-condition' }">
                              <span v-if="language == 'EN'">Terms of Use</span>
                              <span v-else>বিধি ও শর্তাবলী</span>
                            </router-link>
                          </li>
                          <li>
                            <router-link :to="{ path: '/policy' }">
                              <span v-if="language == 'EN'">Privacy Policy</span>
                              <span v-else>প্রাইভেসি পলিসি</span>
                            </router-link>
                          </li>

                        </ul>
                      </div>
                    </div>

                    <div class="sha-footer-copy">
                      © 2026 All rights reserved to
                      <strong>Shah Premium Foods</strong>
                    </div>
                  </div>

                  <div class="sha-footer-right">
                    <div class="sha-app-buttons">
                      <a href="#" class="sha-app-button">
                        <i class="fa fa-play"></i>
                        <span>Android App on<br /><strong>Google Play</strong></span>
                      </a>
                      <a href="#" class="sha-app-button">
                        <i class="fa fa-apple"></i>
                        <span>iPhone App on<br /><strong>App Store</strong></span>
                      </a>
                    </div>
                    <div class="sha-footer-contact">
                      <a href="tel:+33758514154">
                        <i class="fa fa-phone"></i>
                        +33 7 58 51 41 54
                      </a>
                      <span>or</span>
                      <a href="mailto:shahpremiumfoods@gmail.com">
                        shahpremiumfoods@gmail.com
                      </a>
                    </div>
                    <div class="sha-social-links">
                      <a href="#" class="sha-social-facebook" aria-label="Facebook">
                        <i class="fa fa-facebook"></i>
                      </a>
                      <a href="#" class="sha-social-youtube" aria-label="YouTube">
                        <i class="fa fa-youtube-play"></i>
                      </a>
                      <a href="#" class="sha-social-twitter" aria-label="Twitter">
                        <i class="fa fa-twitter"></i>
                      </a>
                      <a href="#" class="sha-social-instagram" aria-label="Instagram">
                        <i class="fa fa-instagram"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
          </div>
        </div>
      </div>
    </div>
    <div id="forgotModal" class="modal authModal fade" role="dialog">
      <div class="vertical-alignment-helper">
        <div class="modal-dialog vertical-align-center">
          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-body">
              <button type="button" class="close" data-dismiss="modal">
                <img src="@/assets/images/close.png" />
              </button>
              <div class="text-center mb40">
                <span class="logo">
                  <img src="@/assets/images/ghasforing-logo.png" class="img-responsive"
                    style="max-width: 150px;margin: auto" alt="Logo" />
                </span>
              </div>
              <div v-if="passwordChangeDone == false">
                <h3>Reset Password</h3>
                <div class="smslabel" id="PassSuccess"></div>
                <div>
                  <input class="form-control checkephone" type="text" placeholder="Your Phone Number"
                    @change="resetPhoneNumbers" v-model="resetPhone" />
                  <button v-if="resetMessage == false" @click="resetPasswordTokenSend" type="button"
                    class="btn btn-login forgot_otp_btn">
                    &nbsp;&nbsp; Send OTP Code in Mobile&nbsp;&nbsp;
                  </button>
                  <div v-if="resetMessage">
                    <input class="form-control" type="text" v-model="reset_otp_code"
                      placeholder="Enter 4-Digit OTP Code here" />
                    <input class="form-control" type="password" v-model="reset_password" placeholder="Set New password"
                      autocomplete="false" />
                    <div class="text-right resendcode" @click="resetPasswordTokenSend">
                      Resend OTP Code
                    </div>
                    <button @click="updatePassword" type="button" class="btn btn-login">
                      &nbsp;&nbsp; Update Password &nbsp;&nbsp;
                    </button>
                  </div>
                </div>
              </div>
              <div v-else>
                <h3>Login Customer</h3>
                <div class="smslabel" id="PassSuccess"></div>
                <div v-if="registerSuccess">
                  <span class="green-color"><i class="fa fa-exclamation-triangle"></i> You have
                    registered Successfully Please Login.</span>
                </div>
                <form v-on:submit.prevent>
                  <div id="cemo"></div>
                  <input required v-model="phone" @change="phoneNumbers" class="form-control checkephone"
                    autocomplete="phone" placeholder="Phone Number" />
                  <input required v-model="password" class="form-control" type="password" autocomplete="password"
                    placeholder="Password" v-on:keyup.enter="loginCustomer" />
                  <a href="#" class="pull-right forgot" @click.prevent="openAuthModal('forgotModal')">forgot Password?</a>
                  <button @click="loginCustomer" type="submit" class="btn btn-login">
                    Login
                  </button>
                </form>
                <div class="text-right in-message">
                  Dont Have an Account?
                  <span @click="openAuthModal('signupModal')">
                    Sign Up</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="loginModal" class="modal authModal fade" role="dialog">
      <div class="vertical-alignment-helper">
        <div class="modal-dialog vertical-align-center">
          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-body">
              <button type="button" class="close" data-dismiss="modal">
                <img src="@/assets/images/close.png" />
              </button>
              <div class="text-center mb40">
                <span class="logo text-center">
                  <img src="@/assets/images/ghasforing-logo.png" class="img-responsive"
                    style="max-width: 150px;margin: auto" alt="Logo" />
                </span>
              </div>
              <div>
                <h3>Login Customer</h3>
                <form v-on:submit.prevent>
                  <div id="cemo"></div>

                  <input required v-model="phone" @change="phoneNumbers" class="form-control checkephone"
                    autocomplete="phone" placeholder="Phone Number" />
                  <input required v-model="password" class="form-control" type="password" autocomplete="password"
                    placeholder="Password" v-on:keyup.enter="loginCustomer" />
                  <a href="#" class="pull-right forgot" @click.prevent="openAuthModal('forgotModal')">forgot Password?</a>
                  <button @click="loginCustomer" type="submit" class="btn btn-login">
                    Login
                  </button>
                </form>
                <div class="text-right in-message">
                  Dont Have an Account?
                  <span @click="openAuthModal('signupModal')">
                    Sign Up</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="vendorModal" class="modal authModal fade" role="dialog">
      <div class="vertical-alignment-helper">
        <div class="modal-dialog vertical-align-center">
          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-body">
              <button type="button" class="close" data-dismiss="modal">
                <img src="@/assets/images/close.png" />
              </button>
              <div class="text-center mb40">
                <span class="logo text-center">
                  <img src="@/assets/images/ghasforing-logo.png" class="img-responsive"
                    style="max-width: 150px;margin: auto" alt="Logo" />
                </span>
              </div>
              <div>
                <h3>Write Your Request</h3>
                <div class="form-group">
                  <input required v-model="vendorphone" class="form-control" placeholder="Your Phone Number" />
                </div>
                <div class="form-group">
                  <textarea class="form-control" v-model="vendorMessage" placeholder="Your Message"></textarea>
                </div>
                <button @click="sendVendorMessage" type="submit" class="btn btn-login">
                  Send Now
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="signupModal" class="modal authModal fade" role="dialog">
      <div class="vertical-alignment-helper">
        <div class="modal-dialog vertical-align-center">
          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-body">
              <button type="button" class="close" data-dismiss="modal">
                <img src="@/assets/images/close.png" />
              </button>
              <div class="text-center mb50">
                <span class="logo">
                  <img src="@/assets/images/ghasforing-logo.png" class="img-responsive"
                    style="max-width: 150px;margin: auto" alt="Logo" />
                </span>
              </div>
              <div id="loginNow"></div>

              <div v-if="otpVerifiedUserCreates">
                <h3>Sign up new Customer:</h3>
                <div class="smslabel" id="OtpSuccess"></div>
                <input class="form-control" type="text" placeholder="Your Name" v-model="your_name" />
                <input class="form-control checkephone" type="text" @change="RegPhoneNumbers"
                  placeholder="Your phone Number" v-model="phone_number" />
                <div>
                  e.g. Phone: 0758514154
                  <!--<span class="existmsg red-color pull-right"> <i class="fa fa-warning"></i> User Already Exist.</span>-->
                </div>
                <button v-if="tokenMessage == false" @click="sendOTPToken" type="button"
                  class="btn btn-login send-token-btn">
                  Send OTP Code
                </button>

                <div v-if="tokenMessage">
                  <input class="form-control" type="text" v-if="tokenMessage" v-model="otp_code"
                    placeholder="Enter 4-Digit OTP Code here" />

                  <input class="form-control" type="password" v-if="tokenMessage" v-model="password"
                    placeholder="password" autocomplete="false" />
                  <div class="text-right resendcode" @click="resendOTP">
                    Resend OTP Code
                  </div>

                  <button @click="registerCustomer" v-if="tokenMessage" type="button" class="btn btn-login">
                    Signup
                  </button>
                </div>
                <div class="text-right in-message">
                  Have an Account?
                  <span @click="openAuthModal('loginModal')">
                    Login</span>
                </div>
              </div>
              <div v-else>
                <h3>Login Customer</h3>
                <div v-if="registerSuccess">
                  <span class="green-color"><i class="fa fa-exclamation-triangle"></i> You have
                    registered Successfully Please Login.</span>
                </div>
                <form v-on:submit.prevent>
                  <div id="cemo"></div>
                  <input required v-model="phone" @change="phoneNumbers" class="form-control checkephone"
                    autocomplete="phone" placeholder="Phone Number" />
                  <input required v-model="password" class="form-control" type="password" autocomplete="password"
                    placeholder="Password" v-on:keyup.enter="loginCustomer" />
                  <a href="#" class="pull-right forgot" @click.prevent="openAuthModal('forgotModal')">forgot Password?</a>
                  <button @click="loginCustomer" type="submit" class="btn btn-login">
                    Login
                  </button>
                </form>
                <div class="text-right in-message">
                  Dont Have an Account?
                  <span @click="openAuthModal('signupModal')">
                    Sign Up</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
//Nice  to  meet  you  jquery
// import JQuery
const $ = require("jquery");
import axios from "axios";
// We declare it globally
//window.$ = $;
window.$ = $;
$(function () {
  jQuery('[data-toggle="tooltip"]').tooltip();
  // $(".cart-data").hide();

  $("body").on("click", ".left-arrow,.mybag.same", function (e) {
    //$(".cart-data").toggle();
    $(".cart-data").toggleClass("show slideInRight");
    $(".cart-data .left-arrow i").toggleClass("fa-angle-right");
  });
  $("body").on("click", ".icon-bottom", function (e) {
    $(".small-device #sidebar-area").removeClass("show");
    $(".cart-data").removeClass("show");
  });

  //$(".existmsg").hide();
  // $("body").on("click", "#sidenav-overlay", function(e) {
  //   $("#sidebar-area").removeClass("show");
  // });

  if ($(window).width() <= 767) {
    // $(".wrapper").toggleClass("small-device");
    // $("body").on("click", "#sidebar-area.show", function(e) {
    //   $("#sidebar-area").removeClass("show");
    // });
  }
});

//import your components here
import header from "./components/header.vue";
import CartData from "./components/CartData";

export default {
  name: "app",
  data() {
    return {
      menuStatus: window.innerWidth > 760,
      token: "",
      name: "",
      email: "",
      phone: "",
      password: "",
      carts: [],
      resetPhone: "",
      isLoggedIn: true,
      isLoading: false,
      activeItem: "",
      singleorder: false,
      searchProduct: "",
      crossIcon: "",
      logged_in_user_name: "",
      otp_code: "",
      tokenMessage: false,
      your_name: "",
      phone_number: "",
      language: "",
      otpVerifiedUserCreates: true,
      registerSuccess: false,
      reset_password: "",
      reset_otp_code: "",
      resetMessage: false,
      passwordChangeDone: false,
      vendorphone: "",
      vendorMessage: "",
      is_seller: 0,
      wishlistCount: 0,
      cart_quantity: 0,
      sum_cart_total: 0,
      mobileMediaQuery: null,
      searchFilterTimer: null
    };
  },
  components: {
    "app-header": header,
    CartData
  },
  mounted() {
    if (localStorage.getItem("token")) {
      let vm = this;
      vm.token = localStorage.getItem("token");
    }
    if (localStorage.getItem("is_seller")) {
      let vm = this;
      vm.is_seller = localStorage.getItem("is_seller");
    }
    if (localStorage.getItem("carts")) {
      let vm = this;
      vm.carts = JSON.parse(localStorage.getItem("carts"));
    }
    this.calculateCartItems();
    this.calculateCartTotal();
    this.updateWishlistCount();
    window.addEventListener("wishlist-updated", this.updateWishlistCount);
    this.mobileMediaQuery = window.matchMedia("(max-width: 760px)");
    if (this.mobileMediaQuery.addEventListener) {
      this.mobileMediaQuery.addEventListener("change", this.handleMobileMediaChange);
    } else {
      this.mobileMediaQuery.addListener(this.handleMobileMediaChange);
    }
  },
  beforeDestroy() {
    window.removeEventListener("wishlist-updated", this.updateWishlistCount);
    clearTimeout(this.searchFilterTimer);
    if (this.mobileMediaQuery) {
      if (this.mobileMediaQuery.removeEventListener) {
        this.mobileMediaQuery.removeEventListener("change", this.handleMobileMediaChange);
      } else {
        this.mobileMediaQuery.removeListener(this.handleMobileMediaChange);
      }
    }
  },
  created: function () {
    //localStorage.clear();
    this.addClass();
    //this.allCategory();
    this.setLanguage();
    this.language = this.globalLanguage;
    this.logged_in_user_name = localStorage.getItem("logged_in_user_name");
    this.syncSearchFromRoute();
  },
  watch: {
    carts: function () {
      this.calculateCartItems();
      this.calculateCartTotal();
    },
    "$route.params.param": function () {
      this.syncSearchFromRoute();
    },
    searchProduct: function (val) {
      clearTimeout(this.searchFilterTimer);
      this.searchFilterTimer = setTimeout(() => {
        this.goSearch();
      }, 300);
    }
    // searchProduct: function (val) {
    //   if (val.length > 0) {
    //     // this.$router.push({ name: 'search', params: { param } }); // -> /user/123
    //     // this.$router.push('/search/');
    //     this.$router.push({path: `/search/${val}`}); // -> /user/123
    //   }
    // }
  },
  computed: {
    showGlobalSideCart: function () {
      const excludedRoutes = ["Cart", "Checkout"];
      const routesWithOwnSideCart = [
        "Online Shop in Gopalganj City",
        "Product Request",
        "CategoryProducts",
        "Product Detail",
        "Delivery Locations",
        "Wishlist",
        "restaurants",
        "Order Food"
      ];
      return (
        !excludedRoutes.includes(this.$route.name) &&
        !routesWithOwnSideCart.includes(this.$route.name)
      );
    }
  },
  methods: {
    toggleSideCart: function () {
      this.refreshCartsFromStorage();
      if (!this.showGlobalSideCart && !$(".cart-data").length) {
        return;
      }
      $(".cart-data").toggleClass("show slideInRight");
      $(".cart-data .left-arrow i").toggleClass("fa-angle-right");
    },
    openAuthModal: function (modalId) {
      let showModal = function (id) {
        let modalSelector = "#" + id;
        let jq = window.jQuery || window.$ || $;
        if (jq && jq.fn && jq.fn.modal) {
          jq(".authModal").modal("hide");
          setTimeout(function () {
            jq(modalSelector).modal("show");
          }, 220);
          return;
        }

        $(".authModal").removeClass("in").hide();
        $(".modal-backdrop").remove();
        $("body").addClass("modal-open");
        $('<div class="modal-backdrop fade in"></div>').appendTo("body");
        $(modalSelector).show().addClass("in").attr("aria-hidden", "false");
      };

      if (modalId == "forgotModal") {
        this.resetMessage = false;
        this.passwordChangeDone = false;
        this.reset_password = "";
        this.reset_otp_code = "";
        $("#PassSuccess").html("");
      }
      showModal(modalId);
    },
    sendVendorMessage: function () {
      if (this.vendorphone.length > 0 && this.vendorMessage.length > 0) {
        axios
          .post(this.globalUrl + "vendor-request", {
            vendorphone: this.vendorphone,
            vendorMessage: this.vendorMessage
          })
          .then(response => {
            this.$toasted.show(
              "Your Request taken. We  will contact with  you soon.",
              {
                type: "success",
                icon: "fa-check-circle"
              }
            );
            this.vendorphone = "";
            this.vendorMessage = "";
          })
          .catch(response => {
            this.$toasted.show("Sorry  Something wrong Try again", {
              type: "error",
              icon: "fa-exclamation-triangle"
            });
          });
      } else {
        this.$toasted.show("Phone & Message Can  not  be  Blank", {
          type: "error",
          icon: "fa-exclamation-triangle"
        });
      }
    },
    goSearch: function () {
      let val = this.searchProduct ? this.searchProduct.trim() : "";
      if (val.length > 0) {
        let path = `/search/${encodeURIComponent(val)}`;
        if (this.$route.path !== path) {
          this.$router.push({ path: path }); // -> /user/123
        }
        // this.$router.push({ name: 'search', params: { param } }); // -> /user/123
        // this.$router.push('/search/');
      }
    },
    syncSearchFromRoute: function () {
      if (this.$route.params.param) {
        this.searchProduct = decodeURIComponent(this.$route.params.param);
      }
    },
    resetPhoneNumbers: function () {
      let phone = this.resetPhone;
      console.log(phone);
      // let check = phone.match(/^(?:\+?88)?01[15-9]\d{8}$/);
      let check = phone.match(/^\d{10}$/);
      console.log(check);
      if (check === null) {
        $(".checkephone").removeClass("success");
        $(".checkephone").addClass("error");
      } else {
        $(".checkephone").removeClass("error");
        $(".checkephone").addClass("success");
      }
    },
    RegPhoneNumbers: function () {
      let phone = this.phone_number;
      //console.log(phone);
      // let check = phone.match(/^(?:\+?88)?01[15-9]\d{8}$/);
      // let check = phone.match(/^(01[3456789])(\d{8})$/);
      let check = phone.match(/^\d{10}$/);      //console.log(check);
      if (check === null) {
        $(".checkephone").removeClass("success");
        $(".checkephone").addClass("error");
      } else {
        $(".checkephone").removeClass("error");
        $(".checkephone").addClass("success");
      }
    },
    phoneNumbers: function () {
      let phone = this.phone;
      console.log(phone);
      // let check = phone.match(/^(?:\+?88)?01[15-9]\d{8}$/);
      let check = phone.match(/^\d{10}$/);;
      //console.log(check);
      if (check === null) {
        $(".checkephone").removeClass("success");
        $(".checkephone").addClass("error");
      } else {
        $(".checkephone").removeClass("error");
        $(".checkephone").addClass("success");
      }
    },
    setLanguage: function () {
      let language = localStorage.getItem("language");
      if (language === null || language == "") {
        localStorage.setItem("language", "BN");
      }
    },
    changeLanguage: function (lang) {
      localStorage.setItem("language", lang);
    },
    toogleNav: function () {
      this.menuStatus = !this.menuStatus;
    },
    closeMobileMenu: function () {
      this.menuStatus = false;
    },
    handleMobileMediaChange: function (e) {
      this.menuStatus = !e.matches;
    },
    hideNav: function () {
      $("#sidenav-navigation").removeClass("show");
      this.menuStatus = true;
    },
    addClass: function () {
      if (this.$route.name == "singleorder") {
        this.singleorder = true;
      }
    },
    calculateCartItems() {
      let vm = this;
      if (typeof vm.carts === "string") {
        vm.carts = JSON.parse(vm.carts || "[]");
      }
      for (
        var i = 0, sum = 0;
        i < vm.carts.length;
        sum += vm.carts[i++].cart_quantity
      );
      vm.cart_quantity = sum;
    },
    calculateCartTotal() {
      let vm = this;
      if (typeof vm.carts === "string") {
        vm.carts = JSON.parse(vm.carts || "[]");
      }
      for (var i = 0, sum = 0; i < vm.carts.length; sum += vm.carts[i++].subtotal);
      vm.sum_cart_total = sum;
    },
    refreshCartsFromStorage() {
      if (localStorage.getItem("carts")) {
        this.carts = JSON.parse(localStorage.getItem("carts"));
      } else {
        this.carts = [];
      }
      this.calculateCartTotal();
      this.calculateCartItems();
    },
    syncCartStorage() {
      localStorage.setItem("carts", JSON.stringify(this.carts));
      this.calculateCartTotal();
      this.calculateCartItems();
    },
    cartIncrement(product_id) {
      let objIndex = this.carts.findIndex(obj => obj.product_id == product_id);
      if (objIndex < 0) return;
      let oldQuantity = this.carts[objIndex].cart_quantity;
      let newQuantity = oldQuantity + 1;
      let price = this.carts[objIndex].price;
      this.carts[objIndex].cart_quantity = newQuantity;
      this.carts[objIndex].subtotal = price * newQuantity;
      this.syncCartStorage();
    },
    cartDecrement(product_id) {
      let objIndex = this.carts.findIndex(obj => obj.product_id == product_id);
      if (objIndex < 0) return;
      let oldQuantity = this.carts[objIndex].cart_quantity;
      if (oldQuantity > 1) {
        let newQuantity = oldQuantity - 1;
        let price = this.carts[objIndex].price;
        this.carts[objIndex].cart_quantity = newQuantity;
        this.carts[objIndex].subtotal = price * newQuantity;
      } else {
        this.carts = this.carts.filter(e => e.product_id !== product_id);
      }
      this.syncCartStorage();
    },
    removeCartItem: function(product_id) {
      this.carts = this.carts.filter(e => e.product_id !== product_id);
      this.syncCartStorage();
    },
    updateWishlistCount() {
      this.wishlistCount = this.getWishlist().length;
    },
    startLoading: function () {
      this.isLoading = true;
    },
    endLoading: function () {
      this.isLoading = false;
    },
    logout: function () {
      // console.log("logout");
      localStorage.removeItem("token");
      localStorage.removeItem("logged_in_user_id");
      localStorage.removeItem("logged_in_user_name");
      localStorage.removeItem("userinfo");
      localStorage.removeItem("is_seller");
      //this.$router.push('/login');
      this.$router.go();
    },
    loginCustomer: function () {
      let vm = this;
      this.startLoading();
      axios
        .post(
          this.globalUrl + "login",
          {
            //email: 'ad@gmail.com',
            //password: '123123',
            phone: this.phone,
            password: this.password
          },
          { crossdomain: true }
        )
        .then(response => {
          //this.endLoading();
          //console.log(response.data);
          localStorage.setItem("token", "Bearer " + response.data.token);
          vm.getProfile();
          this.$toasted.show("Login Successful", {
            type: "success",
            icon: "fa-check-circle"
          });
        })
        .catch(response => {
          //console.log(response);
          this.endLoading();
          this.$toasted.show("Username Or Password Wrong Please Try again", {
            type: "error",
            icon: "fa-exclamation-triangle"
          });
        });
    },
    increment() {
      this.quantity++;
    },
    decrement() {
      if (this.quantity === 1) {
      } else {
        this.quantity--;
      }
    },

    updatePassword: function () {
      if (this.reset_otp_code && this.reset_password && this.resetPhone) {
        axios
          .post(
            this.globalUrl + "password/resetpassword",
            {
              password: this.reset_password,
              phone: this.resetPhone,
              token: this.reset_otp_code
            },
            { crossdomain: true }
          )
          .then(response => {
            //console.log(response);
            if (response.data.status == 30) {
              $("#PassSuccess").html(response.data.message);
              this.resetMessage = true;
              this.passwordChangeDone = true;
              this.phone = this.resetPhone;
              this.password = this.reset_password;
            } else if (response.data.status == 31) {
              $("#PassSuccess").html(response.data.message);
            }
            //else if (response.data.status = 32) {
            //   $('#PassSuccess')
            //     .html(response.data.message);
            // }
          })
          .catch(response => {
            //console.log(response);
          });
      } else {
        if (this.resetPhone == "") {
          this.$toasted.show("Phone Number can  not be  Blank.", {
            type: "error",
            icon: "fa-exclamation-triangle"
          });
        }
        if (this.reset_password == "") {
          this.$toasted.show("Password can  not be  Blank.", {
            type: "error",
            icon: "fa-exclamation-triangle"
          });
        }
        if (this.reset_otp_code == "") {
          this.$toasted.show("OTP can  not be  Blank.", {
            type: "error",
            icon: "fa-exclamation-triangle"
          });
        }
      }
    },
    resetPasswordTokenSend: function () {
      let vm = this;
      if (this.resetPhone) {
        let check = this.resetPhone.match(/^\d{10}$/);
        //console.log(check);
        if (check != null) {
          $(".forgot_otp_btn").addClass("disabled");
          setTimeout(function () {
            $(".forgot_otp_btn").removeClass("disabled");
          }, 5000);
          //console.log(this.resetPhone);
          //axios.post(this.globalUrl+'password/email',
          axios
            .post(
              this.globalUrl + "password/phone",
              {
                //email: this.resetEmail,
                phone: "88" + this.resetPhone
              },
              { crossdomain: true }
            )
            .then(response => {
              //console.log(response);
              if (response.data.status == 20) {
                $("#PassSuccess").html(response.data.message);
                this.resetMessage = true;
              } else if (response.data.status == 21) {
                $("#PassSuccess").html(response.data.message);
              }
            })
            .catch(response => {
              // console.log(response);
              this.$toasted.show(
                "Sorry  Phone Number is not  valid  please  try again",
                {
                  type: "error",
                  icon: "fa-exclamation-triangle"
                }
              );
            });
        } else {
          $("#PassSuccess").html(
            "<span class='red-color'><i class='fa fa-exclamation-triangle'></i> Phone Number is  not Valid</span>"
          );
        }
      } else {
        this.$toasted.show("Sorry  Phone Number can not  be Blank.", {
          type: "error",
          icon: "fa-exclamation-triangle"
        });
      }
    },
    getProfile() {
      let vm = this;
      //console.log(localStorage.getItem("token"));
      //https://blog.pusher.com/laravel-jwt/
      axios
        .get(this.globalUrl + "user", {
          headers: { Authorization: localStorage.getItem("token") }
        })
        .then(response => {
          //console.log(response);
          localStorage.setItem(
            "is_seller",
            JSON.stringify(response.data.is_seller)
          );
          //alert(JSON.stringify(response.data));
          localStorage.setItem(
            "logged_in_user_id",
            JSON.stringify(response.data.user.id)
          );
          localStorage.setItem("logged_in_user_name", response.data.user.name);
          localStorage.setItem("userinfo", JSON.stringify(response.data.user));
          this.$router.go(this.$router.currentRoute);
          //vm.$router.go('/');
          //vm.$parent.endLoading();
          //vm.$router.push('/products');
          //this.$router.go(this.$router.currentRoute);
          // vm.$router.go('/');
        })
        .catch(response => {
          //end loading
          //vm.$parent.endLoading();
          //console.log(response);
        });
      //console.log("token:" + vm.token);
    },
    isActive: function (menuItem) {
      return this.activeItem === menuItem;
    },
    setActive: function (menuItem) {
      this.activeItem = menuItem; // no need for Vue.set()
    },

    resendOTP: function () {
      //console.log('clicked');
      $(".resendcode").addClass("disabled");
      setTimeout(function () {
        $(".resendcode").removeClass("disabled");
      }, 9000);

      axios
        .post(
          this.globalUrl + "send-otp-token",
          {
            phone: this.resetPhone
          },
          { crossdomain: true }
        )
        .then(response => {
          //this.$refs['loginModal'].show();
          console.log(response);
          if (response.data.status != 9) {
            this.tokenMessage = true;
            this.$toasted.show("New Token send  in  your  Mobile.", {
              type: "success",
              icon: "fa-check-circle",
              duration: 10000
            });
          }
          $("#OtpSuccess").html(response.data.message);
        })
        .catch(response => {
          //console.log(response);
          $("#OtpSuccess").html(response.data.message);
        });
    },
    sendOTPToken: function () {
      //console.log(this.your_name);

      if (this.your_name && this.phone_number) {
        let check = this.phone_number.match(/^\d{10}$/);
        //console.log(check);
        if (check != null) {
          setTimeout(function () {
            $(".send-token-btn").addClass("disabled");
          });
          axios
            .post(
              this.globalUrl + "send-otp-token",
              {
                name: this.your_name,
                phone: this.phone_number
              },
              { crossdomain: true }
            )
            .then(response => {
              setTimeout(function () {
                $(".send-token-btn").removeClass("disabled");
              });
              //this.$refs['loginModal'].show();
              //console.log(response);
              if (response.data.status != 9) {
                this.tokenMessage = true;
              }
              $("#OtpSuccess").html(response.data.message);
            })
            .catch(response => {
              //console.log(response);
              $("#OtpSuccess").html(response.data.message);
            });
        } else {
          this.$toasted.show("Phone number is not valid.", {
            type: "error",
            icon: "fa-exclamation-triangle",
            duration: 10000
          });
        }
      } else {
        if (this.your_name == "") {
          this.$toasted.show("Name Can not be Blank.", {
            type: "error",
            icon: "fa-exclamation-triangle",
            duration: 10000
          });
        }
        if (this.phone_number == "") {
          this.$toasted.show("Phone Number Can  not be Blank.", {
            type: "error",
            icon: "fa-exclamation-triangle",
            duration: 10000
          });
        }
      }
    },
    registerCustomer: function () {
      let vm = this;
      //this.startLoading();
      //console.log(this.globalUrl+'register');
      if (
        this.your_name &&
        this.phone_number &&
        this.otp_code &&
        this.password
      ) {
        axios
          .post(
            this.globalUrl + "register",
            {
              name: this.your_name,
              phone: this.phone_number,
              token: this.otp_code,
              password: this.password
            },
            { crossdomain: true }
          )
          .then(response => {
            //console.log(response);
            if (response.data.status == 12) {
              $("#OtpSuccess").html(response.data.message);
            } else if (response.data.status == 13) {
              //this.tokenMessage=false;
              this.otpVerifiedUserCreates = false;
              //console.log(response.data.message);
              //$('#loginNow').html(response.data.message);
              this.registerSuccess = true;
              this.phone = this.phone_number;
              this.password = this.password;
            }

            //this.endLoading();
            //this.$refs['loginModal'].show();

            // if(response.data==1){
            // }else{
            // this.tokenMessage=true;
            // }
          })
          .catch(response => {
            //console.log(response);
            this.endLoading();
            this.$toasted.show("Something Wrong Please Try again", {
              type: "error",
              icon: "fa-exclamation-triangle",
              duration: 10000
            });
            //console.log(response);
          });
      } else {
        if (this.your_name == "") {
          this.$toasted.show("Name Can not be Blank.", {
            type: "error",
            icon: "fa-exclamation-triangle",
            duration: 10000
          });
        }
        if (this.phone_number == "") {
          this.$toasted.show("Phone Number Can  not be Blank.", {
            type: "error",
            icon: "fa-exclamation-triangle",
            duration: 10000
          });
        }
        if (this.password == "") {
          this.$toasted.show("Password Can  not be Blank.", {
            type: "error",
            icon: "fa-exclamation-triangle",
            duration: 10000
          });
        }
        if (this.otp_code == "") {
          this.$toasted.show("OTP Can  not be Blank.", {
            type: "error",
            icon: "fa-exclamation-triangle",
            duration: 10000
          });
        }
      }
    }
  }
};
</script>
<style lang="css">
@import "assets/scss/animate.min.css";
</style>
<style lang="scss">
@import "assets/scss/base/global.scss";
@import "assets/scss/base/variables.scss";
@import "assets/scss/style.scss";
@import "assets/scss/design-overrides.scss";
</style>
